module.exports = __webpack_public_path__ + "img/watermelon.be5030ca.webp";